export const ApiQueryKey = {
	auth: 'auth',

	projects: 'projects',
	productTypes: 'product-types',
	productTypeCategories: 'product-type-categories',

	investments: 'investments',
	investmentItems: 'investment-items',
	investmentStatusHistories: 'investment-status-histories',

	components: 'components',
	componentVariations: 'component-variations',

	admins: 'admins',
	users: 'users',
	companies: 'companies',
	adminLoginEvents: 'admin-login-events',

	colorGroups: 'color-groups',
	colors: 'colors',

	articles: 'articles',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	roles: 'roles',
	content: 'content',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
